import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
// import { files } from './example-data';


const ENG_YOUTUBE_URL = {
  0: 'https://www.youtube.com/embed/qpxwokjC8-U',
  1: 'https://www.youtube.com/embed/nSTRu3UYWMQ',
  2: 'https://www.youtube.com/embed/-JqMqYpqOak',
  3: 'https://www.youtube.com/embed/zQJ7FOvDuvw',
};

const NLD_YOUTUBE_URL = {
  0: 'https://www.youtube.com/embed/Gd6qLywZHDQ',
  1: 'https://www.youtube.com/embed/7X0o2qwSL_Q',
  2: 'https://www.youtube.com/embed/C69zIzGieig',
  3: 'https://www.youtube.com/embed/zQJ7FOvDuvw',
};


@Component({
  selector: 'app-get-start',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.scss'],
})

export class GetStartComponent implements OnInit, AfterViewInit {

  safeURLfirst;
  safeURLSecond;
  safeURLThird;
  safeURLFourth;
  safeURL = {};
  activeIds = 'toggle-1';
  showGettingStartedClips = environment.showGettingStartedClips;
  showMobileAppOption = environment.showMobileAppOption;
  showFacebookButton = environment.showFacebookButton;
  constructor(
    private _sanitizer: DomSanitizer,
    private router: Router,
    public translater: TranslateService,
  ) {
    const browserLang = this.translater.getBrowserLang();
    if (browserLang === 'nl' || browserLang === 'nl-be' ) {
      Object.keys(NLD_YOUTUBE_URL).forEach(e => {
        this.safeURL[e] = this._sanitizer.bypassSecurityTrustResourceUrl(NLD_YOUTUBE_URL[e]);
      });
    } else {
      Object.keys(ENG_YOUTUBE_URL).forEach(e => {
        this.safeURL[e] = this._sanitizer.bypassSecurityTrustResourceUrl(ENG_YOUTUBE_URL[e]);
      });
    }
    // this.safeURLfirst = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/qpxwokjC8-U');
    // this.safeURLSecond = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/nSTRu3UYWMQ');
    // this.safeURLThird = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/-JqMqYpqOak');
    // this.safeURLFourth = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/zQJ7FOvDuvw');
  }

  ngOnInit() {
    this.translater.onLangChange.subscribe((e) => {
      console.log(e);
      if (e.lang === 'NLD') {
        Object.keys(NLD_YOUTUBE_URL).forEach(e => {
          this.safeURL[e] = this._sanitizer.bypassSecurityTrustResourceUrl(NLD_YOUTUBE_URL[e]);
        });
      } else {
        Object.keys(ENG_YOUTUBE_URL).forEach(e => {
          this.safeURL[e] = this._sanitizer.bypassSecurityTrustResourceUrl(ENG_YOUTUBE_URL[e]);
        });
      }
    });
   }

  ngAfterViewInit() {
    if(!this.showGettingStartedClips && this.showMobileAppOption){
      this.activeIds = "toggle-2";
    }
    else if(!this.showGettingStartedClips && !this.showMobileAppOption){
      this.activeIds = "toggle-3";
    }
    else{
      this.activeIds = "toggle-1";
    }
  }

  onCreateTripHandler() {
    localStorage.setItem('help-btn', JSON.stringify(true));
    this.router.navigate(['/', 'trips'], { state: { skipGuard: true } });
  }
}
